import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";


@Component({
  selector: 'app-offers-list',
  templateUrl: './offers-list.component.html'
})
export class OffersListComponent implements OnInit {

  public slug = '';
  banner_image = './assets/images/banners/be-inspired-banner.jpg';

  category = {
    id: '',
    title: '',
    content: '',
    cover_image: ''
  };
  offers = [];
  regions = [];
  categories = [];
  selected_regions = '';
  selected_categories = '';

  next = null;


  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.next = null;
      if (params.slug) {
        this.slug = params['slug'];
        this.getCategory();
      }
      this.getOffer();
    });
    this.getCategories();
  }

  selectCategory(slug) {
    this.slug = slug;
    this.getOffer()
  }

  getCategory() {
    this.http.get(Conf.API_URL + '/category-for-offer/?slug=' + this.slug).subscribe(
        data => {
          this.category.title = data['results'][0]['title'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCategories() {
    this.http.get(Conf.API_URL + '/category-for-offer/?show_all&count=0').subscribe(
        data => {
          this.categories = data['results'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  choseRegion() {
    this.selected_regions = $('input[name="location"]:checked').map(function () {
      return $(this).val();
    }).get().join(',');
    this.getOffer();
  }

  getOffer() {
    var url = Conf.API_URL + '/offer/?category=' + this.slug;

    this.http.get(url).subscribe(
        data => {
          this.offers = data['results'];
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  loadMore() {
    this.http.get(this.next).subscribe(
        data => {
          this.offers = this.offers.concat(data['results']);
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  firstParagraph(html) {
    return FunctionsService.firstParagraph(html)
  }
}




// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/offers-list/offers-list.component.ts